import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '~/Services/api';
import Header from '~/Components/Header';
import Loading from '~/Components/Loading';
import ScrollToTopButton from '~/Components/ScrollToTopButton';
import GenericModal from '~/Components/GenericModal';
import { FaFilter, FaTrashAlt } from 'react-icons/fa';
import SelecaoSolicitacao from '~/Components/ConsultaDespesaProjeto/SelecaoSolicitacao';
import CardSolicitacao from '~/Components/ConsultaDespesaProjeto/CardSolicitacao';
import Select from 'react-select';
import {
  blankView,
  modalViewsSolicitacaoDespesaProjeto,
  ordenacaoSolicitacao,
} from '../Negocios/CaixaAprovacao/options';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constants';
import OrderBy from '~/Components/OrderBy';
import ModalAprovarReprovarSolicitacao from '~/Components/ConsultaDespesaProjeto/ModalAprovarReprovarSolicitacao';
import { TIPOS_SOLICITACAO } from '~/constants';

export default function ConsultaSolicitacao() {
  const abortControllerRef = useRef(null);

  const podeFiltrarPorGrupo =
    !AuthStorage.temCaracteristica(caracteristicas.GerenciaSolicitacao) &&
    !AuthStorage.temCaracteristica(caracteristicas.VisualizaSolicitacaoLanc);

  const [filtros, setFiltros] = useState({
    codigo_solicitacao: '',
    codigo_usuario: '',
    codigo_ges: '',
    status_solicitacoes: '',
    data: '',
    codigo_despesa_projeto_tipo_solicitacao: '',
    codigos_usuarios_grupo: '',
  });

  const [filtrosTemporarios, setFiltrosTemporarios] = useState({
    codigo_solicitacao: '',
    codigo_usuario: '',
    codigo_ges: '',
    status_solicitacoes: '',
    data: '',
    codigo_despesa_projeto_tipo_solicitacao: '',
    codigos_usuarios_grupo: '',
  });

  const [filtrosAplicados, setFiltrosAplicados] = useState({
    codigo_usuario: '',
    status_solicitacoes: '',
    data: '',
    codigo_despesa_projeto_tipo_solicitacao: '',
  });

  const [ordenacao, setOrdenacao] = useState(ordenacaoSolicitacao[0]);
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [solicitacoesSelecionadas, setSolicitacoesSelecionadas] = useState([]);
  const [showInfo, setShowInfo] = useState(false);
  const [modalView, setModalView] = useState(blankView);
  const [mostrarModalFiltros, setMostrarModalFiltros] = useState(false);

  const [mostrarModalAprovacaoReprovacao, setMostrarModalAprovacaoReprovacao] =
    useState(false);
  const [aprovando, setAprovando] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [gesOptions, setGesOptions] = useState();
  const [usuariosGrupoOptions, setUsuariosGrupoOptions] = useState([]);

  const selecionarSolicitacao = useCallback(
    async solicitacao => {
      try {
        if (
          !AuthStorage.temCaracteristica(caracteristicas.GerenciaSolicitacao)
        ) {
          return;
        }

        solicitacao.selected = !solicitacao.selected;

        await api.verificarStatusEResponsavelAnalise(
          solicitacao.codigo_solicitacao
        );

        if (solicitacao.selected) {
          const existente = solicitacoes.find(
            c => c.codigo_solicitacao === solicitacao.codigo_solicitacao
          );
          setSolicitacoesSelecionadas(prev => [...prev, existente]);
        } else {
          setSolicitacoesSelecionadas(prev =>
            prev.filter(
              c => c.codigo_solicitacao !== solicitacao.codigo_solicitacao
            )
          );
        }
      } catch (error) {
        toast.error(error.message);
        solicitacao.selected = false;
      }
    },
    [solicitacoes]
  );

  const adicionarFiltro = nomeProp => value => {
    setFiltrosTemporarios(prevFiltros => ({
      ...prevFiltros,
      [nomeProp]: value,
    }));
  };

  const aplicarFiltros = () => {
    setFiltros(filtrosTemporarios);
    setMostrarModalFiltros(false);
    consultarSolicitacoes(filtrosTemporarios);
  };

  const limparFiltros = () => {
    const filtrosVazios = {
      codigo_usuario: '',
      status_solicitacoes: '',
      data: '',
      codigo_grupo_empresa: '',
      codigo_fornecedor: '',
      codigo_despesa_projeto_tipo_solicitacao: '',
      codigos_usuarios_grupo: '',
    };
    setFiltros(filtrosVazios);
    setFiltrosTemporarios(filtrosVazios);
    setFiltrosAplicados(filtrosVazios);
    setMostrarModalFiltros(false);
    setfornecedoresOptions([]);
    setGesOptions([]);

    consultarSolicitacoes(filtrosVazios);
  };

  const toggleInfoModal = (solicitacao, infoType, parameter = null) => {
    const isShowing = !showInfo;
    setShowInfo(isShowing);
    if (isShowing) {
      const view = modalViewsSolicitacaoDespesaProjeto[infoType];
      view.solicitacao = solicitacao;
      view.content = parameter || solicitacao;
      setModalView(view);
    } else setModalView(blankView);
  };

  const consultarSolicitacoes = async request => {
    try {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();
      const { signal } = abortControllerRef.current;

      setCarregando(true);

      const filteredRequest = Object.keys(request).reduce((acc, key) => {
        if (
          request[key] !== '' &&
          request[key] !== null &&
          request[key] !== undefined
        ) {
          acc[key] = request[key];
        }
        return acc;
      }, {});

      const response = await api.buscarSolicitacoes(request, signal);

      if (response && !signal.aborted) {
        const solicitacoesOrdenadas = [...response].sort(ordenacao.func);
        setSolicitacoes(solicitacoesOrdenadas);
        setFiltrosAplicados(filteredRequest);
        if (!('codigo_solicitacao' in filteredRequest)) {
          setCodigoSolicitacaoOptions(construirOpcoesCodigo(response));
        }
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        toast.error('Erro ao buscar solicitações:', error);
      }
    } finally {
      if (!abortControllerRef.current?.signal.aborted) {
        setCarregando(false);
      }
    }
  };

  const limparSolicitacoes = () => {
    const novasSolicitacoes = solicitacoes.map(solicitacao => {
      solicitacao.selected = false;
      return solicitacao;
    });
    setSolicitacoes(novasSolicitacoes);
    setSolicitacoesSelecionadas([]);
  };

  const selecionarTodas = () => {
    const novasSolicitacoesSelecionadas = solicitacoes.map(solicitacao => {
      solicitacao.selected = true;
      return solicitacao;
    });
    setSolicitacoesSelecionadas(novasSolicitacoesSelecionadas);
  };
  const [codigoSolicitacaoOptions, setCodigoSolicitacaoOptions] = useState([]);
  const construirOpcoesCodigo = dados => {
    const lista = [
      ...new Set((dados || []).map(s => s?.codigo_solicitacao)),
    ].map(c => ({ value: String(c), label: String(c) }));

    return lista;
  };
  const obterUsuarioValidos = () => {
    let usuarios = solicitacoes.map(s => ({
      value: s.codigo_usuario,
      label:
        s.codigo_usuario +
        ' - ' +
        s.nome_usuario +
        ' - ' +
        s.nome_usuario_completo,
    }));

    return Array.from(new Map(usuarios.map(u => [u.value, u])).values());
  };

  const reordenarOpcoes = e => {
    const novaOrdenacao = ordenacaoSolicitacao.find(
      o => o.value === e.target.value
    );

    if (novaOrdenacao) {
      setOrdenacao(novaOrdenacao);
      const solicitacesOrdenadas = [...solicitacoes].sort(novaOrdenacao.func);
      setSolicitacoes(solicitacesOrdenadas);
    }
  };

  const aprovandoOuRecusando = (aprovando = true) => {
    setMostrarModalAprovacaoReprovacao(true);
    setAprovando(aprovando);
  };

  const carregarUsuariosGrupo = async () => {
    try {
      const resp = await api.buscarUsuariosMesmoGrupoDepartamento();
      if (resp) {
        setUsuariosGrupoOptions(
          resp.map(u => ({
            value: u.codigo_usuario,
            label:
              u.codigo_usuario +
              ' - ' +
              (u.nome_completo ? u.nome_completo : u.apelido),
          }))
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    consultarSolicitacoes({});
    if (podeFiltrarPorGrupo) {
      carregarUsuariosGrupo();
    }
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);
  useEffect(() => {
    if (solicitacoes.length > 0 && ordenacao.func) {
      const solicitacesOrdenadas = [...solicitacoes].sort(ordenacao.func);
      setSolicitacoes(solicitacesOrdenadas);
    }
  }, [ordenacao]);

  const abrirModalFiltros = () => {
    setFiltrosTemporarios(filtros);
    setMostrarModalFiltros(true);
    obterGesValidos();
  };

  const obterGesValidos = async codigo_usuario => {
    try {
      setCarregando(true);
      const response = await api.buscarGesValidos(codigo_usuario);
      if (response) {
        setGesOptions(
          [
            { value: '', label: 'Selecione...' },
            ...response.map(ge => ({
              value: ge.codigo,
              label: `${ge.codigo} - ${ge.descricao}`,
            })),
          ].sort()
        );
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCarregando(false);
    }
  };

  const [fornecedoresOptions, setfornecedoresOptions] = useState();
  const obterFiltrosFornecedores = async ge => {
    try {
      if (ge) {
        setCarregando(true);
        const response = await api.obterFiltrosFornecedores(ge);

        if (response) {
          let fornecedoresTipoDespesa = [
            { value: '', label: 'Selecione...' },
            ...response.fornecedores.map(fornecedor => ({
              value: fornecedor.codigo,
              label: `${fornecedor.codigo} - ${fornecedor.descricao}`,
            })),
          ];

          let fornecedoresTipoProjeto = [
            { value: '', label: 'Selecione...' },
            ...response.fornecedores_tipo_projeto.map(fornecedor => ({
              value: fornecedor.codigo,
              label: `${fornecedor.codigo} - ${fornecedor.descricao}`,
            })),
          ];

          setfornecedoresOptions([
            {
              label: 'Tipo fornecedor DESPESA',
              options: fornecedoresTipoDespesa,
            },
            {
              label: 'Tipo fornecedor PROJETO',
              options: fornecedoresTipoProjeto,
            },
          ]);
        }
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setCarregando(false);
    }
  };

  const duasColunasDeFornecedores = true;

  return (
    <>
      <Header title="Consulta de Solicitações">
        <Button
          onClick={() => {
            consultarSolicitacoes({});
          }}
          disabled={carregando}
        >
          ATUALIZAR
        </Button>
      </Header>
      {carregando && (
        <>
          <Loading />
        </>
      )}
      {!carregando && (
        <div className="container flex-fill">
          <div className="row">
            {AuthStorage.temCaracteristica(
              caracteristicas.GerenciaSolicitacao
            ) && (
              <div className="col-12 col-md-4 order-md-2 mb-4 ">
                <SelecaoSolicitacao
                  solicitacoesSelecionadas={solicitacoesSelecionadas}
                  selecionarTodos={() => {
                    selecionarTodas();
                  }}
                  Aprovar={() => {
                    aprovandoOuRecusando(true);
                  }}
                  Reprovar={() => {
                    aprovandoOuRecusando(false);
                  }}
                  limparSelecao={() => {
                    limparSolicitacoes();
                  }}
                />
              </div>
            )}
            <div
              className={`col-12 ${
                AuthStorage.temCaracteristica(
                  caracteristicas.GerenciaSolicitacao
                )
                  ? 'col-md-8'
                  : 'col-md-12'
              }`}
            >
              <div className="mt-2 d-sm-flex justify-content-between align-items-center">
                <span className="mr-auto w-50">
                  <strong>{solicitacoes.length}</strong> Solicitações
                  encontradas
                </span>
                <OrderBy
                  options={ordenacaoSolicitacao}
                  value={ordenacao.value}
                  onChange={reordenarOpcoes}
                />
                <Button
                  className="ml-2 mr-1 mt-1 btn-sm d-flex align-items-center"
                  variant="primary"
                  onClick={abrirModalFiltros}
                >
                  <FaFilter className="mr-1" />
                  Filtros
                </Button>
                <Button
                  className="mt-1 btn-sm d-flex align-items-center"
                  variant="secondary"
                  onClick={() => {
                    limparFiltros();
                  }}
                >
                  <FaTrashAlt className="mr-1" />
                  Limpar
                </Button>
              </div>
              <div className="row mt-3">
                <div className="col-12">
                  {filtrosAplicados.codigo_usuario && (
                    <span className="badge badge-primary mr-2">
                      Usuário: {filtrosAplicados.codigo_usuario}
                    </span>
                  )}
                  {filtrosAplicados.data && (
                    <span className="badge badge-primary mr-2">
                      Data: {filtrosAplicados.data}
                    </span>
                  )}
                  {filtrosAplicados.status_solicitacoes && (
                    <span className="badge badge-primary mr-2">
                      Status:{' '}
                      {filtrosAplicados.status_solicitacoes
                        .split(',')
                        .map(value => {
                          const labels = {
                            1: 'Solicitado',
                            2: 'Processado',
                            3: 'Reprovado',
                            4: 'Em análise',
                            5: 'Ajustado',
                          };
                          return labels[value];
                        })
                        .join(', ')}
                    </span>
                  )}
                  {filtrosAplicados.codigo_despesa_projeto_tipo_solicitacao && (
                    <span className="badge badge-primary mr-2">
                      Tipo:{' '}
                      {(() => {
                        switch (
                          filtrosAplicados.codigo_despesa_projeto_tipo_solicitacao
                        ) {
                          case TIPOS_SOLICITACAO.Despesa:
                            return 'Despesa';
                          case TIPOS_SOLICITACAO.Projeto:
                            return 'Projeto';
                          case TIPOS_SOLICITACAO.Comissao:
                            return 'Comissão';
                          case TIPOS_SOLICITACAO.DespesaCartaoCredito:
                            return 'Despesa Cartão de Crédito';
                          default:
                            return '';
                        }
                      })()}
                    </span>
                  )}
                </div>
              </div>
              {solicitacoes.map((solicitacao, index) => (
                <CardSolicitacao
                  key={`${solicitacao.codigo_solicitacao}-${index}-${ordenacao.value}`}
                  solicitacao={solicitacao}
                  onCardClick={() => selecionarSolicitacao(solicitacao)}
                  mostrarDetalhes={toggleInfoModal}
                />
              ))}
            </div>
          </div>
          <ScrollToTopButton
            scrollStepInPx="50"
            delayInMs="16.66"
            className="d-block d-sm-none"
          />
        </div>
      )}
      <ModalAprovarReprovarSolicitacao
        show={mostrarModalAprovacaoReprovacao}
        onCancel={() => setMostrarModalAprovacaoReprovacao(false)}
        aprovando={aprovando}
        solicitacoes={solicitacoesSelecionadas}
        limparSolicitacoes={limparSolicitacoes}
        consultarSolicitacoes={consultarSolicitacoes}
      />
      <GenericModal
        show={showInfo}
        title={modalView.title}
        onCancel={toggleInfoModal}
        content={modalView.render(modalView.content)}
        size={'lg'}
        dialogClassName={
          modalView.title === 'Digitalização' ? 'modal-digitalizacao' : ''
        }
      />
      <Modal
        show={mostrarModalFiltros}
        onHide={() => setMostrarModalFiltros(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Filtros</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2">
            <div className="row mb-2">
              <div className="col-md-12">
                <label>Chave</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Selecione o codigo da chave"
                  name="codigo_solicitacao"
                  options={codigoSolicitacaoOptions}
                  value={codigoSolicitacaoOptions.find(
                    option =>
                      option.value ===
                      (filtrosTemporarios.codigo_solicitacao || '')
                  )}
                  onChange={selectedOption => {
                    const valor = selectedOption?.value || '';
                    const novoFiltroTemp = {
                      ...filtrosTemporarios,
                      codigo_solicitacao: valor,
                    };
                    setFiltrosTemporarios(novoFiltroTemp);
                    consultarSolicitacoes(novoFiltroTemp);
                  }}
                  isClearable={true}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <label>Tipo de Solicitação</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Selecione o tipo..."
                  name="codigo_despesa_projeto_tipo_solicitacao"
                  options={[
                    { value: '', label: 'Todos' },
                    { value: 1, label: 'Despesa' },
                    { value: 2, label: 'Projeto' },
                    { value: 3, label: 'Comissão' },
                    { value: 4, label: 'Despesa Cartão de Crédito' },
                  ]}
                  value={[
                    { value: '', label: 'Todos' },
                    { value: 1, label: 'Despesa' },
                    { value: 2, label: 'Projeto' },
                    { value: 3, label: 'Comissão' },
                    { value: 4, label: 'Despesa Cartão de Crédito' },
                  ].find(
                    option =>
                      option.value ===
                      filtrosTemporarios.codigo_despesa_projeto_tipo_solicitacao
                  )}
                  onChange={selectedOption => {
                    const valor = selectedOption?.value || '';
                    const novoFiltroTemp = {
                      ...filtrosTemporarios,
                      codigo_despesa_projeto_tipo_solicitacao: valor,
                    };
                    setFiltrosTemporarios(novoFiltroTemp);
                    consultarSolicitacoes(novoFiltroTemp);
                  }}
                  isClearable={true}
                />
              </div>
            </div>

            {podeFiltrarPorGrupo && usuariosGrupoOptions.length > 0 && (
              <div className="row">
                <div className="col-md-12 mt-2">
                  <label>Usuários do meu grupo</label>
                  <Select
                    isMulti={true}
                    placeholder="Selecione colegas do seu grupo..."
                    options={usuariosGrupoOptions}
                    value={usuariosGrupoOptions.filter(op => {
                      const csv = filtrosTemporarios.codigos_usuarios_grupo || '';
                      return csv.split(',').indexOf(String(op.value)) !== -1;
                    })}
                    onChange={selectedOptions => {
                      const csv = selectedOptions
                        ? selectedOptions.map(o => o.value).join(',')
                        : '';
                      const novoFiltroTemp = {
                        ...filtrosTemporarios,
                        codigos_usuarios_grupo: csv,
                      };
                      setFiltrosTemporarios(novoFiltroTemp);
                      consultarSolicitacoes(novoFiltroTemp);
                    }}
                    className="basic-single"
                    classNamePrefix="select"
                  />
                </div>
              </div>
            )}

            <div className="row mt-2">
              {AuthStorage.temCaracteristica(
                caracteristicas.GerenciaSolicitacao
              ) ||
                (AuthStorage.temCaracteristica(
                  caracteristicas.VisualizaSolicitacaoLanc
                ) && (
                  <div className="col-md-12">
                    <label>Usuário</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      placeholder="Selecione o usuário"
                      name="codigo_usuario"
                      options={obterUsuarioValidos()}
                      value={obterUsuarioValidos().find(
                        option =>
                          option.value === filtrosTemporarios.codigo_usuario
                      )}
                      onChange={selectedOption => {
                        const valor = selectedOption?.value || '';
                        const novoFiltroTemp = {
                          ...filtrosTemporarios,
                          codigo_usuario: valor,
                        };
                        setFiltrosTemporarios(novoFiltroTemp);
                        consultarSolicitacoes(novoFiltroTemp);
                      }}
                      isClearable={true}
                    />
                  </div>
                ))}
            </div>

            <div className="row">
              <div className="col-md-12 mt-2">
                <label>GE</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Selecione um grupo empresa"
                  name="codigo_grupo_empresa"
                  options={gesOptions || []}
                  value={(gesOptions || []).find(
                    option =>
                      option.value === filtrosTemporarios.codigo_grupo_empresa
                  )}
                  onChange={selectedOption => {
                    const valor = selectedOption?.value || '';
                    const novoFiltroTemp = {
                      ...filtrosTemporarios,
                      codigo_grupo_empresa: valor,
                    };
                    setFiltrosTemporarios(novoFiltroTemp);
                    consultarSolicitacoes(novoFiltroTemp);
                    obterFiltrosFornecedores(selectedOption?.value);
                  }}
                  isClearable={true}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mt-2">
                <label>Fornecedor</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  styles={{
                    menuList: base => ({
                      ...base,
                      ...(duasColunasDeFornecedores
                        ? {
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '8px',
                          }
                        : {}),
                    }),
                    group: base => ({
                      ...base,
                      margin: 0,
                    }),
                    groupHeading: base => ({
                      ...base,
                      textAlign: 'center',
                      borderBottom: '1px solid #ddd',
                      paddingBottom: 4,
                      fontSize: 12,
                    }),
                    option: base => ({
                      ...base,
                      cursor: 'pointer',
                    }),
                  }}
                  placeholder="Selecione um grupo empresa"
                  name="codigo_fornecedor"
                  options={fornecedoresOptions || []}
                  value={
                    filtrosTemporarios.codigo_fornecedor
                      ? (fornecedoresOptions || []).find(
                          option =>
                            option.value ===
                            filtrosTemporarios.codigo_fornecedor
                        )
                      : { label: 'Selecione um Fornecedor', value: '' }
                  }
                  onChange={selectedOption => {
                    const valor = selectedOption?.value || '';
                    const novoFiltroTemp = {
                      ...filtrosTemporarios,
                      codigo_fornecedor: valor,
                    };
                    setFiltrosTemporarios(novoFiltroTemp);
                    consultarSolicitacoes(novoFiltroTemp);
                    obterFiltrosFornecedores(selectedOption?.value);
                  }}
                  disabled={!fornecedoresOptions || carregando}
                  isClearable={true}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 mt-2">
                <label>Status</label>
                <Select
                  isMulti={true}
                  placeholder="Selecione os status..."
                  options={[
                    { value: '1', label: 'Solicitado' },
                    { value: '2', label: 'Processado' },
                    { value: '3', label: 'Reprovado' },
                    { value: '4', label: 'Em análise' },
                    { value: '5', label: 'Ajustado' },
                  ]}
                  value={
                    filtrosTemporarios.status_solicitacoes
                      ? filtrosTemporarios.status_solicitacoes
                          .split(',')
                          .map(value => ({
                            value,
                            label: {
                              1: 'Solicitado',
                              2: 'Processado',
                              3: 'Reprovado',
                              4: 'Em análise',
                              5: 'Ajustado',
                            }[value],
                          }))
                      : []
                  }
                  onChange={selectedOptions => {
                    adicionarFiltro('status_solicitacoes')(
                      selectedOptions
                        ? selectedOptions.map(option => option.value).join(',')
                        : ''
                    );
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 mt-2">
                <label>Data</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosTemporarios.data}
                  onChange={e => {
                    const valor = e.target.value;
                    const novoFiltroTemp = {
                      ...filtrosTemporarios,
                      data: valor,
                    };
                    setFiltrosTemporarios(novoFiltroTemp);
                    consultarSolicitacoes(novoFiltroTemp);
                  }}
                  onKeyDown={e => e.preventDefault()}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              aplicarFiltros();
            }}
          >
            Aplicar Filtros
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
